import PropTypes from 'prop-types';
import { NumberField } from 'react-admin';
import { Box } from '@mui/material';

export const ContainerSumWithIcon = ({ record, source, icon: Icon }) => (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <Icon aria-hidden />
        <NumberField source={source} record={record} />
    </Box>
);

ContainerSumWithIcon.propTypes = {
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
    icon: PropTypes.elementType.isRequired,
};
